import { useForm } from "react-hook-form";
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { Attendance, AttendanceRequest } from "../../../service/model/attendance.model";
import { Box, Button, Dialog, DialogTitle, Grid, TextField } from "@mui/material";
import FormField from "../../../components/form-controls/form-field";
import theme from "../../../app/app-theme";
import { DateTimeInput } from "../../../components/form-input-field-wrappers/datetime-input";
import dayjs from "dayjs";
import FormCloseButton from "../../../components/form-controls/form-close-button";

interface AttendanceFormProps {
    readonly attendance?: Attendance
    readonly editable: boolean
    readonly onClose: () => void
    readonly onSubmit: (data: AttendanceRequest) => void
}

const style = {
    // position: 'absolute' as 'absolute',
    // top: '50%',
    // left: '50%',
    // transform: 'translate(-50%, -50%)',
    // width: 400,
    // bgcolor: 'background.paper',
    // border: '2px solid #000',
    // boxShadow: 24,
    p: 2,
};

const schema = yup.object().shape({
    checkIn: yup.string().required()
});

export type FormValues = yup.InferType<typeof schema>;

const AttendanceForm: React.FC<AttendanceFormProps> = ({ attendance, onClose, onSubmit }) => {


    const { register, handleSubmit, control, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            checkIn: attendance?.checkIn ? attendance.checkIn : dayjs().format('YYYY-MM-DDTHH:mm')
        }
    });

    const onSubmitHandler = (data: any) => {
        const updatedAttendance = {
            ...attendance,
            ...data,
            checkIn: dayjs(data.checkIn).format("YYYY-MM-DDTHH:mm")
        }
        onSubmit(updatedAttendance as AttendanceRequest)
    };

    return (
        <Dialog open={true} onClose={onClose} sx={style}>
            <DialogTitle>Attendance Details</DialogTitle>
            <Box sx={style}>
                <>
                    <FormCloseButton onClose={onClose} />
                    <form onSubmit={handleSubmit(onSubmitHandler)}>
                        <FormField>
                            <TextField
                                id="name"
                                label="Name"
                                variant="outlined"
                                defaultValue={attendance?.memberName ?? ''}
                                disabled={true}
                            />
                        </FormField>
                        <FormField>
                            <DateTimeInput
                                id="checkIn"
                                name="checkIn"
                                control={control}
                                label="Check In"
                                error={errors.checkIn !== undefined}
                                helperText={errors.checkIn?.message}
                                register={register('checkIn')}
                            />
                        </FormField>
                        <Grid container direction="row" justifyContent='end' sx={{ mt: 1 }}>
                            <Button type="button" variant="contained" sx={{ mr: 1, bgcolor: `${theme.palette.secondary.main}` }} onClick={onClose}>Cancel</Button>
                            <Button type="submit" variant="contained" >Submit</Button>
                        </Grid>
                    </form>
                </>
            </Box>
        </Dialog>
    );
}

export default AttendanceForm;